import { ComponentType, IconType } from '../types';

function createEditorConfig() {
  const componentList: ComponentType[] = [];

  return {
    componentList,

    registerCommon(component: ComponentType) {
      componentList.push(component);
    },
  };
}

export const registerConfig = createEditorConfig();

let comList = [
  {
    component: 'Pcr',
    text: 'PCR模组',
    index: 0,
    place: '',
    data: {
      // udiNeedTime: '100', //剩余时间
      uiPCRTimeRemainingH: 0, //PCR剩余时间H时
      uiPCRTimeRemainingM: 0, //PCR剩余时间M分
      uiPCRTimeRemainingS: 0, //PCR剩余时间S秒
      iPcrDoorStatus: '0', // 门状态
      //  0 已关闭
      // 1 已打开
      // 2 正在关闭
      // 3 正在打开
      iPcrRunStatus: '0', //运行状态
      // 0 未运行
      // 1 运行中
      // 2 暂停中
      // 3 运行完成
      // 4 故障中
      // 5 热盖加热中
      // 6 hold状态
      // 7 soak状态
      uiPcrStartNum: '1', //执行程序号
      rModTempe: '', //实时温度，通道温度
      rHotLidTempe: '', //热盖温度

      imgStatus: '1',
      bPcrStart: false, // 图片状态 false是s0，true是s1
      bDoorOpen: true, //开盖 false开盖 true开盖中
      bDoorClose: true, //关盖 false关盖 true关盖中
      bDoorHalfOpen: true, //翻盖 false 翻盖 true翻盖完成
    },
    width: 160,
    height: 251,
  },
  {
    component: 'GunTips',
    text: '50uL取枪区',
    index: 0,
    place: '',
    data: {
      aTipsNumberPerColumn: [0, 1, 2, 3, 4, 5, 6, 7, 8, 7, 6, 5],
    },
    width: 160,
    height: 121,
  },
  {
    component: 'GunTips',
    text: '200uL取枪区',
    index: 0,
    place: '',
    data: {
      aTipsNumberPerColumn: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    width: 160,
    height: 121,
  },

  {
    component: 'GunTips',
    text: '1000uL取枪区',
    index: 0,
    place: '',
    data: {
      aTipsNumberPerColumn: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    width: 160,
    height: 121,
  },
  {
    component: 'GunFrame',
    text: '50uL枪架 ',
    index: 0,
    place: '',
    data: {
      aTipsState: false, //有枪true 无枪false.。图片状态也是这个
      aTipsNum: '0', //层数
    },
    width: 160,
    height: 121,
  },

  {
    component: 'GunFrame',
    text: '200uL枪架 ',
    index: 0,
    place: '',
    data: {
      aTipsState: false, //有枪true 无枪false.。图片状态也是这个
      aTipsNum: '0', //层数
    },
    width: 160,
    height: 121,
  },

  {
    component: 'GunFrame',
    text: '1000uL枪架 ',
    index: 0,
    place: '',
    data: {
      aTipsState: false, //有枪true 无枪false.。图片状态也是这个
      aTipsNum: '0', //层数
    },
    width: 160,
    height: 121,
  },

  {
    component: 'TemperatureControl',
    text: 'PCR温控模组',
    index: 0,
    place: '',
    data: {
      aSetpoint: '0', // 设置温度
      aoutval: '0', // 实时温度
      astarrun: false, // 开始控温  false停止控温 true开始控温
      astoprun: false, // 停止控温  false停止控温 true停止控温
      bPcrStart: false, // 图片状态 false是s0，true是s1
    },
    width: 160,
    height: 121,
  },
  {
    component: 'KitTemp96',
    text: '96试剂温控模组',
    index: 0,
    place: '',
    data: {
      aSetpoint: '0', // 设置温度
      aoutval: '0', // 实时温度
      astarrun: false, // 开始控温  false停止控温 true开始控温
      astoprun: false, // 停止控温  false停止控温 true停止控温
      bPcrStart: false, // 图片状态 false是s0，true是s1
    },
    width: 330,
    height: 121,
  },

  {
    component: 'KitTemp48',
    text: '48试剂温控模组',
    index: 0,
    place: '',
    data: {
      aSetpoint: '0', // 设置温度
      aoutval: '0', // 实时温度
      astarrun: false, // 开始控温  false停止控温 true开始控温
      astoprun: false, // 停止控温  false停止控温 true停止控温
      bPcrStart: false, // 图片状态 false是s0，true是s1
    },
    width: 160,
    height: 121,
  },

  {
    component: 'Quantitative',
    text: '定量模块',
    index: 0,
    place: '',
    data: {
      aQubManuData: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0], //浓度
      byQubManuRequestNum: 0, //定量数量
      iQubUserVolume: 0, //样本投入体积
      bQubManuStarRequest: false, //定开始定量  false 开始定量 true定量中
      bPcrStart: false, // 图片状态 false是s0，true是s1
    },
    width: 80,
    height: 121,
  },
  {
    component: 'Qubit',
    text: 'Qubit液槽',
    index: 0,
    place: '',
    data: {
      status: '2',
      bPcrStart: false, // 图片状态 false是s0，true是s1
    },
    width: 80,
    height: 121,
  },

  {
    component: 'FourTemp',
    text: '四列常温试剂区',
    index: 0,
    place: '',
    data: {
      bPcrStart: false, // 图片状态 false是s0，true是s1
    },
    width: 160,
    height: 121,
  },

  {
    component: 'NormalTemp96',
    text: '96孔常温试剂区',
    index: 0,
    place: '',
    data: {
      bPcrStart: false, // 图片状态 false是s0，true是s1
    },
    width: 160,
    height: 121,
  },
  {
    component: 'MagneticAttraction',
    text: '磁吸模组',
    index: 0,
    place: '',
    data: {
      uiManulMagGears: '0', //磁吸档位
      bGoMagGears: false, //定位
      bPcrStart: false, // 图片状态 false是s0，true是s1
    },
    width: 160,
    height: 121,
  },

  {
    component: 'CleanPcr',
    text: '洁净PCR板',
    index: 0,
    place: '',
    data: {
      byPCRNum_NEW: 0, //层数
      bPcrStart: false, // 图片状态 false是s0，true是s1
    },
    width: 160,
    height: 121,
  },

  {
    component: 'AbandonedPcr',
    text: '废弃PCR板',
    index: 0,
    place: '',
    data: {
      byPCRNum_Old: 0, //层数
      bPcrStart: false, // 图片状态 false是s0，true是s1
    },
    width: 160,
    height: 121,
  },
  // 定量缓存槽  每列有五个状态    共 12列

  {
    component: 'QuantitativeCache',
    text: '定量缓存槽',
    index: 0,
    place: '',
    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    width: 160,
    height: 121,
  },

  {
    component: 'Oscillation',
    text: '震荡模块',
    index: 0,
    place: '',
    data: {
      uiShockGearsNum: 0, //震荡速度
      bCOOLShockStop: false, //震荡停止
      bCOOLShockRun: false, //震荡开始
      bPcrStart: false, // 图片状态 false是s0，true是s1
    },
    width: 160,
    height: 121,
  },
  {
    component: 'ConstantOscillation',
    text: '恒温震荡模块',
    index: 0,
    place: '',
    data: {
      aoutval: 0, // 实时温度
      aSetpoint: 0, // 设定温度
      astarrun: false, // 开始控温  false停止控温 true开始控温
      astoprun: false, // 停止控温  false停止控温 true停止控温
      uiShockGearsNum: 0, //震荡速度
      bCOOLShockStop: false, //震荡停止
      bCOOLShockRun: false, //震荡开始
      bPcrStart: false, // 图片状态 false是s0，true是s1
    },
    width: 160,
    height: 121,
  },
  // 一列两行
  {
    component: 'Recycling1',
    text: '废弃区1',
    index: 0,
    place: '',
    data: {
      floor: '38',
      status: '2',
    },
    width: 160,
    height: 251,
  },
  // 一行两列
  {
    component: 'Recycling2',
    text: '废弃区2',
    index: 0,
    place: '',
    data: {
      floor: '38',
      status: '2',
    },
    width: 330,
    height: 121,
  },

  // {
  //   component: 'span',
  //   text: '文本',
  //   style: {
  //     fontSize: 18,
  //     color: '#333',
  //   },
  // },
  // {
  //   component: 'a-button',
  //   text: '按钮',
  // },
  // {
  //   component: 'div',
  //   text: '矩形',
  //   style: { border: '1px solid var(--el-text-color-primary)' },
  // },
  // {
  //   component: 'div',
  //   text: '圆形',
  //   width: 100,
  //   height: 100,
  //   style: {
  //     border: '1px solid var(--el-text-color-primary)',
  //     borderRadius: '50%',
  //   },
  // },
];

comList.forEach((item) => {
  registerConfig.registerCommon(item as ComponentType);
});
